import { Component, OnInit, TemplateRef } from "@angular/core";
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { BsModalService } from "ngx-bootstrap/modal";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-company-attachment",
  templateUrl: "./company-attachment.component.html",
  styleUrls: ["./company-attachment.component.css"],
})
export class CompanyAttachmentComponent implements OnInit {
  registerForm: FormGroup;
  config = {
    class: "modal-dialog-centered",
    backdrop: true,
    ignoreBackdropClick: true,
  };
  submitted = false;
  showcompany: any;
  showstatus: any;
  showaccount: any;
  showstream: any;
  showcategory: any;
  showpayment: any;
  showdelivery: any;
  value: any;
  userid: any;
  parent: any;
  countryListArray: any = [];
  dropdownSettings: any = {};
  dropdownDesignation: any = {};
  CountryList: any = [];
  dropdownCountry: any = {};
  dropdownState: any = {};
  selectedState: any = [];
  dropdownCity;
  any = {};
  cityArray: any = [];
  cityList: any = [];
  selectedCity: any[];
  id: any;
  profiledata: any;
  selectedBusiness: any = [];
  selectedBusinessName: string = "";
  selectedBusinessNameId: string = "";
  CompanyId: any;
  companydata: any;
  urlMediaTitle: any;
  type: any;
  mediaUploadDisplay: boolean;
  totalMediaSize: any;
  file_upload_loader: boolean;
  fileUploadCount: any;
  imgURL: any;
  postMediaGraterThanCheckError: string;
  allowDragover: boolean;
  pasteEvnetStatus: boolean;
  totalMediaLength: number;
  fileUpload: any;
  videoURL: any[];
  fileUploadLoader: boolean;
  clicked: boolean;
  filesname: any;
  modalRef: any;
  delNameDel: boolean;
  preview: string;
  isMediabtnClicked: boolean;
  upload_disable: boolean;
  mediaPostLoader: boolean;
  mediaPostTextTemp: string;
  mediaPostArr: {};
  postTextWithLink: string;
  urlMediaDescription: any;
  urlDescription: any;
  urlMediaiframe: any;
  isPrivacySettingsMediaPostBtnEnable: boolean;
  urlMediaLink: any;
  sharePostArr: {};
  urlImage: any;
  urlTitle: any;
  isImagePasted: boolean;
  iframe: any;
  urlLink: any;
  isCollapsed: any;
  file: any;
  downloadurl: string;
  url: any = "";
  permission: any;
  filesid: any;
  uploadImageUrl: string;
  uploadFileIcon: string;
  uploadFileFormat: string;
  userRId: any;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private UserService: UserService
  ) {}

  mobnumPattern = "^((\\+91-?)|0)?[0-9]{6,15}$";
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  reg = "^(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";

  ngOnInit(): void {
    let editid = localStorage.getItem("editcid");
    editid = editid
      .toString()
      .replace("Ar1t", "=")
      .replace("FGH", "/")
      .replace("THD", "+");
    this.id = this.UserService.decryptData(editid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    this.downloadurl = environment.app_downpath;
    this.url = environment.app_path;
    this.uploadImageUrl = environment.upload_image_url;
    this.uploadFileIcon = environment.upload_file_icon;
    this.uploadFileFormat = environment.upload_file_format;

    this.registerForm = this.formBuilder.group({
      CompanyName: ["", Validators.required],
      ParentCompany: ["", Validators.required],
      CompanyTypeId: ["", Validators.required],
      CompanyProfileId: ["", Validators.required],
      BusinessStreamId: ["", Validators.required],
      AccountManager: ["", Validators.required],
      CategoryId: ["", Validators.required],
      Mobile: [
        "",
        [
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(this.mobnumPattern),
        ],
      ],
      Landline: ["", Validators.required],
      CountryId: ["", Validators.required],
      PaymentHistoryId: [""],
      FinancialStatusId: [""],
      SupplierDeliveryHistoryId: [""],
      KeyAccounts: [""],
      ClientTime: [""],
      StateId: ["", Validators.required],
      CityId: ["", Validators.required],
      MapLocation: ["", [Validators.pattern(this.reg)]],
      Fax: [""],
      Email: ["", [Validators.required, Validators.email]],
      Website: [""],
      AddressLine1: [""],
      AddressLine2: [""],
      AddressLine3: [""],
      PostalCode: [""],
      Remarks: [""],
      CreatedBy: this.userid,
    });

    let data = {
      CompanyId: this.id,
      Mode: "Edit",
    };
    this.spinner.show();
    this.UserService.GetEditCompanyDetail(data).subscribe((res) => {
      this.spinner.hide();
      this.CompanyId = res["Data"]["CompanyId"];
      this.companydata = res["UploadDocument"];
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  openModal(template: TemplateRef<any>, type: any) {
    this.type = type;
    this.isMediabtnClicked = false;
    this.mediaUploadDisplay = true;
    this.totalMediaSize = 0;
    this.totalMediaLength = 0;
    this.modalRef = this.modalService.show(template, this.config);
    this.upload_disable = true;
    this.preview = "";
    this.fileUpload = [];
    this.fileUpload = [];
    this.imgURL = [];
    this.mediaPostTextTemp = "";
    this.mediaPostLoader = true;
    this.mediaPostArr = {};
    this.allowDragover = false; //to close the drag box
    //Add Post show url details variables(n)
    this.postTextWithLink = "";
    this.sharePostArr = {};
    this.urlMediaTitle = this.urlTitle;
    this.urlMediaDescription = this.urlDescription;
    this.urlMediaiframe = this.urlImage;
    this.urlMediaLink = this.urlLink;
    this.urlMediaiframe = this.iframe;
    this.isPrivacySettingsMediaPostBtnEnable = false;
    this.urlTitle = "";
    this.urlDescription = "";
    this.urlImage = "";
    this.urlLink = "";
    this.iframe = "";
    //End Add Post show url details variables(n)
    this.fileUploadCount = 0;

    // Show the error massege while the post file size is grater than 20 mb.(D)
    this.postMediaGraterThanCheckError = "";

    //End Post Text With media upload variable(a)
  }

  closeModalFileUplaodFalse() {
    this.file_upload_loader = false;
    this.imgURL = [];
    this.videoURL = [];
    this.fileUpload = [];
    this.isImagePasted = false;
    this.pasteEvnetStatus = true;
  }

  fileChangeEvent(event: any) {
    let file_array = [];
    let uploadFileIcon = environment.upload_file_icon;

    this.allowDragover = false;
    if (event?.target?.files) {
      file_array = event.target.files;
      this.totalMediaLength += file_array.length;
      if (this.totalMediaLength <= 5) {
        let x = 0;

        while (x < file_array.length) {
          let fileDetails = file_array[x];

          this.totalMediaSize += fileDetails.size;
          if (this.totalMediaSize <= "20971520") {
            if (
              fileDetails.type == "image/png" ||
              fileDetails.type == "image/jpeg" ||
              fileDetails.type == "image/webp" ||
              fileDetails.type == "image/gif" ||
              fileDetails.type == "image/x-icon" ||
              fileDetails.type == "image/bmp"
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                $this_func.setupReader(fileDetails, x, file_array.length);
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
              });
            } else if (
              fileDetails.type == "video/mp4" ||
              fileDetails.type == "video/webm" ||
              fileDetails.type == "video/ogg" ||
              fileDetails.type == "video/quicktime"
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                $this_func.setupReader(fileDetails, x, file_array.length);
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
              });
            } else if (
              fileDetails.type == "audio/ogg" ||
              fileDetails.type == "audio/mpeg" ||
              fileDetails.type == "audio/vnd.dlna.adts"
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                if (fileDetails.type.includes("audio/")) {
                  switch (fileDetails.type) {
                    case "audio/ogg":
                      $this_func.imgURL.push({
                        url: uploadFileIcon + "ogg.png",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;

                    case "audio/mpeg":
                      $this_func.imgURL.push({
                        url: uploadFileIcon + "mp3.png",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;

                    case "audio/vnd.dlna.adts":
                      $this_func.imgURL.push({
                        url: uploadFileIcon + "aac.png",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;

                    default:
                      $this_func.imgURL.push({
                        url: this.uploadFileFormat + "audio.webp",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;
                  }
                }
                $this_func.fileUpload.push(fileDetails);
                $this_func.fileUploadCount = $this_func.fileUpload.length;
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
                if (x == file_array.length) {
                  $this_func.file_upload_loader = false;
                }
              });
            } else if (
              fileDetails.type == "application/vnd.ms-excel" ||
              fileDetails.type == "application/msword" ||
              fileDetails.type ==
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
              fileDetails.type ==
                "application/vnd.oasis.opendocument.spreadsheet" ||
              fileDetails.type ==
                "application/vnd.oasis.opendocument.spreadsheet" ||
              fileDetails.type == "application/pdf" ||
              fileDetails.type ==
                "application/vnd.ms-powerpointapplication/vnd.ms-powerpoint" ||
              fileDetails.type ==
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
              fileDetails.type ==
                "application/vnd.ms-word.document.macroEnabled.12" ||
              fileDetails.type == "text/plain" ||
              fileDetails.type == "application/vnd.ms-powerpoint"
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                switch (fileDetails.type) {
                  case "application/vnd.ms-excel":
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "csv.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "excel.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.oasis.opendocument.spreadsheet":
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "excel.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/pdf":
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "pdf.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.ms-powerpointapplication/vnd.ms-powerpoint":
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "ppt.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "word.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/msword":
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "word.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.ms-word.document.macroEnabled.12":
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "word.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "text/plain":
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "txt.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.ms-powerpoint":
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "ppt.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  default:
                    $this_func.imgURL.push({
                      url: uploadFileIcon + "file.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;
                }
                $this_func.fileUpload.push(fileDetails);
                $this_func.fileUploadCount = $this_func.fileUpload.length;
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
                if (x == file_array.length) {
                  $this_func.file_upload_loader = false;
                }
              });
            } else {
              this.totalMediaSize -= fileDetails.size;
              this.totalMediaLength = this.totalMediaLength - 1;
              if (x + 1 == file_array.length) {
                this.file_upload_loader = false;
              }
              if (fileDetails.type.includes("image/")) {
                this.toastr.error(
                  "Images can't be uploaded. Only jpg, jpeg, png, webp, ico, bmp and gif files are allowed!",
                  "Error!"
                );
              } else if (fileDetails.type.includes("video/")) {
                this.toastr.error(
                  "Video can't be uploaded. Only MP4, Mov webm and ogg files are allowed!",
                  "Error!"
                );
              } else if (fileDetails.type.includes("audio/")) {
                this.toastr.error(
                  "Audio can't be uploaded. Only mp3, aac and ogg files are allowed!",
                  "Error!"
                );
              } else if (
                fileDetails.type.includes("application/") ||
                fileDetails.type.includes("text/")
              ) {
                this.toastr.error(
                  "File can't be uploaded. Only CSV,XLS,XLSX,DOC,DOCX,DOCM,PDF,TXT,PPT files are allowed!",
                  "Error!"
                );
              } else if (fileDetails.type == "" || fileDetails.type == null) {
                this.toastr.error("File can't supported", "Error!");
              } else {
                this.toastr.error(
                  "File can't be uploaded. Only Image, Audio, Video and Doc files are allowed!",
                  "Error!"
                );
              }
              x++;
            }
          } else {
            this.totalMediaSize -= fileDetails.size;
            this.toastr.error(
              "File can't be uploaded. Total File size should be smaller than 20 MB.",
              "Error!"
            );
            if (x + 1 == file_array.length) {
              this.file_upload_loader = false;
            }
            this.totalMediaLength = 0;
            x++;
          }
        }
      } else {
        this.totalMediaLength -= file_array.length;
        this.toastr.error(
          "Unable to upload more than 5 file at a time.",
          "Error!"
        );
      }
    } else {
      this.toastr.error(
        "File can't be uploaded. Only Image, Audio, Video and Doc files are allowed!",
        "Error!"
      );
    }
  }
  //End Calling the change event whent the media is selected in the local file (n) edid (D)

  // Onclick the remove tage remove the current image(D)
  RemoveImage(data, key) {
    this.totalMediaSize = +this.totalMediaSize - +data.size;
    this.totalMediaLength = this.totalMediaLength - 1;
    this.pasteEvnetStatus = true;
    this.imgURL.splice(key, 1);
    this.fileUpload.splice(key, 1);
    this.file_upload_loader = false;
    this.postMediaGraterThanCheckError = "";
    this.allowDragover = false;
  }
  //End  Onclick the remove tage remove the current image(D)

  //Setup Reader method for converting img into base64 for preview(D)
  setupReader(file, num, file_length) {
    try {
      let fileReader = new FileReader();
      let $this = this;
      if (file.type.match("image")) {
        if (file.size < "20971520") {
          fileReader.onload = function () {
            $this.imgURL.push({
              url: fileReader.result,
              size: file.size,
              type: "image",
              name: file.name,
            });
            $this.fileUpload.push(file);
            $this.fileUploadCount = $this.fileUpload.length;

            if (num + 1 == file_length) {
              $this.file_upload_loader = false;
            }
            $this.pasteEvnetStatus = true;
          };
          fileReader.readAsDataURL(file);
        } else {
          $this.imgURL.push({
            url: this.uploadImageUrl + "image_preview.jpg",
            size: file.size,
            type: "image",
            name: file.name,
          });
          $this.fileUpload.push(file);
          $this.fileUploadCount = $this.fileUpload.length;

          if (num + 1 == file_length) {
            $this.file_upload_loader = false;
          }
          $this.pasteEvnetStatus = true;
        }
      }
    } catch (error) {
      this.imgURL.push({
        url: this.uploadImageUrl + "no_preview.jpg",
        size: file.size,
        type: "image",
        name: file.name,
      });
      this.fileUpload.push(file);
      this.fileUploadCount = this.fileUpload.length;

      if (num + 1 == file_length) {
        this.file_upload_loader = false;
      }
      this.pasteEvnetStatus = true;
    }
  }

  addMediaPost(mediaPostArr, type) {
    this.totalMediaSize = 0;
    this.totalMediaLength = 0;
    this.file_upload_loader = true;
    this.imgURL = [];
    this.videoURL = [];
    let data = new FormData();
    data.append("CompanyId", this.id);
    for (const file of this.fileUpload) {
      data.append("file[]", file);
    }
    this.spinner.show();
    this.UserService.UploadCompanyDocument(data).subscribe(
      (res) => {
        this.fileUploadLoader = false;
        if (res?.["result"] === "success") {
          this.toastr.success(res["Msg"], "Success!");
          this.spinner.hide();
          this.fileUploadCount = 0;
          this.fileUploadLoader = false;
          this.fileUpload = [];
          this.closeModalFileUplaodFalse();
          this.ngOnInit();
        }
      },
      (err) => {
        this.fileUploadLoader = false;
        if (err?.error?.result === "failed" && err?.error?.Msg) {
          this.toastr.error(err["error"]["Msg"], "Error!");
          localStorage.removeItem("token");
          this.router.navigate([
            "/company/editcompany/" + this.id + "/user-attachment",
          ]);
        } else if (err?.Msg) {
          this.toastr.error(
            "File not uploaded. You may have slow internet speed or uploaded media size is too large.",
            "Error!"
          );
        }
      }
    );
    this.clicked = false;
  }

  deleteOpenModal(template: TemplateRef<any>, data) {
    if (data) {
      this.filesid = data.FileId;
      this.filesname = data.FileName;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  deleteConfirm() {
    this.deletefileinfo();
    this.modalRef.hide();
  }

  deletefileinfo() {
    this.delNameDel = true;
    let Data = {
      CompanyId: this.CompanyId,
      FileId: this.filesid,
    };
    this.spinner.show();
    this.UserService.removecompanydocument(Data).subscribe(
      (res) => {
        this.delNameDel = false;
        if (res && res["result"] == "success") {
          this.modalRef.hide();
          this.spinner.hide();
          this.ngOnInit();
          this.toastr.success(res["Msg"], "Success!");
        }
      },
      (err) => {
        this.delNameDel = false;
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
          this.modalRef.hide();
          this.spinner.hide();
        }
      }
    );
  }

  decline() {
    this.modalRef.hide();
  }

  downloadModal(template: TemplateRef<any>, data) {
    if (data) {
      this.CompanyId = data.CompanyId;
      this.filesname = data.FileName;
      this.file = data.UrlPath;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  downloadConfirm() {
    this.download();
    this.modalRef.hide();
  }

  download(): any {
    window.open(this.downloadurl + this.filesname);
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }
}
